import { Provider } from '@angular/core';
import { APP_MENU_DEFINITION, APP_MENU_SECTIONS, AppMenuLeafDef, AppMenuSectionDef } from '@app/core/constants/app-menu.definition';

/**
 * Définition menu côté `custom`.
 * Tu peux ici:
 * - remplacer complètement `APP_MENU_SECTIONS`
 * - ou faire un merge/override (ex. ajouter des entrées à une section existante)
 */
function cloneMenu(sections: readonly AppMenuSectionDef[]): AppMenuSectionDef[] {
  return sections.map((s) => ({
    ...s,
    items: s.items.map((i) => ({ ...i })),
  }));
}

function removeSectionsByLabel(sections: AppMenuSectionDef[], labels: readonly string[]): AppMenuSectionDef[] {
  const set = new Set(labels);
  return sections.filter((s) => !set.has(s.label));
}

function removeItemsByRouterLink(sections: AppMenuSectionDef[], routerLinks: readonly string[]): AppMenuSectionDef[] {
  const set = new Set(routerLinks);
  return sections.map((s) => ({
    ...s,
    items: s.items.filter((i) => !(i.routerLink && set.has(i.routerLink))),
  }));
}

function findSectionIndex(sections: AppMenuSectionDef[], by: { label: string }): number {
  return sections.findIndex((s) => s.label === by.label);
}

function findItemIndex(items: readonly AppMenuLeafDef[], by: { routerLink?: string; label?: string }): number {
  if (by.routerLink) {
    const idx = items.findIndex((i) => i.routerLink === by.routerLink);
    if (idx !== -1) return idx;
  }
  if (by.label) {
    return items.findIndex((i) => i.label === by.label);
  }
  return -1;
}

function insertItemIntoSection(
  sections: AppMenuSectionDef[],
  section: { label: string },
  item: AppMenuLeafDef,
  where: { index?: number; before?: { routerLink?: string; label?: string }; after?: { routerLink?: string; label?: string } } = {},
): AppMenuSectionDef[] {
  const sIdx = findSectionIndex(sections, section);
  if (sIdx === -1) return sections;
  const s = sections[sIdx];
  const nextItems = [...s.items];

  let insertAt = where.index ?? -1;
  if (insertAt < 0 && where.before) {
    const idx = findItemIndex(nextItems, where.before);
    if (idx !== -1) insertAt = idx;
  }
  if (insertAt < 0 && where.after) {
    const idx = findItemIndex(nextItems, where.after);
    if (idx !== -1) insertAt = idx + 1;
  }
  if (insertAt < 0) insertAt = nextItems.length;

  nextItems.splice(insertAt, 0, item);
  const nextSections = [...sections];
  nextSections[sIdx] = { ...s, items: nextItems };
  return nextSections;
}

function buildCustomMenu(): readonly AppMenuSectionDef[] {
  // Base core
  let sections = cloneMenu(APP_MENU_SECTIONS);

  // 1) Supprimer des sections complètes
  sections = removeSectionsByLabel(sections, [
    // 'Administration',
  ]);

  // 2) Supprimer des items (par routerLink)
  sections = removeItemsByRouterLink(sections, [
    // '/moni/reductions',
  ]);

  // 3) Ajouter un item exactement où tu veux (avant / après / index)
  // sections = insertItemIntoSection(
  //   sections,
  //   { label: 'Contacts' },
  //   {
  //     label: 'Enfants',
  //     icon: 'text-xl fa-light fa-users',
  //     routerLink: '/moni/enfants',
  //     roleEditorSkip: true,
  //   },
  //   { after: { label: 'Particuliers' } },
  // );

  // // 4) Ajouter une section custom (et la placer où tu veux en splicant)
  // const customSection: AppMenuSectionDef = {
  //   label: 'Custom',
  //   icon: 'text-xl pi pi-star',
  //   items: [
  //     {
  //       label: 'Entrée custom',
  //       icon: 'text-xl pi pi-star',
  //       routerLink: '/moni/dashboard',
  //       roleEditorSkip: true,
  //     },
  //   ],
  // };
  // // Ex: insérer juste après "Contacts"
  // const contactsIdx = findSectionIndex(sections, { label: 'Contacts' });
  // if (contactsIdx !== -1) {
  //   sections.splice(contactsIdx + 1, 0, customSection);
  // } else {
  //   sections.push(customSection);
  // }

  return sections;
}

export function provideCustomAppMenuDefinition(): Provider {
  return { provide: APP_MENU_DEFINITION, useFactory: () => buildCustomMenu() };
}

